import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { color } from '@/styles';

const Trigger = css`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${color.white};
  font-size: 16px;
  font-weight: bold;
  text-decoration: underline;
  white-space: nowrap;
  cursor: help;
  user-select: none;
`;

const PopupContent = css`
  width: 400px;
  color: ${color.dark_gray};
  text-align: center;
`;

const PopupTitle = css`
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: bold;
`;

const PopupList = css`
  margin: 0 auto;
  display: inline-block;
  text-align: left;
  li {
    margin-bottom: 6px;
    font-size: 16px;
  }
`;

const PopupLink = css`
  margin-top: 8px;
  display: inline-block;
  font-size: 16px;
  color: ${color.green};
  text-decoration: underline;
`;

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.arrow}`]: {
    color: color.bg_light_green,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
    backgroundColor: color.bg_light_green,
    padding: '20px 24px',
  },
});

export const BigBladderNotificationHintTooltip = React.memo(() => {
  return (
    <CustomTooltip
      placement='bottom-start'
      title={
        <div css={PopupContent}>
          <div css={PopupTitle}>
            {'実際の様子とズレがある場合は、以下お試しいただくといいかもしれません。'}
          </div>
          <ul css={PopupList}>
            <li>{'そろそろラインの数値を調整する'}</li>
            <li>{'DFreeの装着位置を調整する'}</li>
            <li>{'排尿前後の状態からケアに活かす'}</li>
          </ul>
          <a
            css={PopupLink}
            href='https://dfree.biz/professional/support#solutions_notice_07'
            target='_blank'
            rel='noopener noreferrer'
          >
            {'詳しくは「困った時の対処法」へ'}
          </a>
        </div>
      }
    >
      <div css={Trigger}>
        <InfoOutlined sx={{ fontSize: 24, color: color.white }} />
        {'実際の様子とズレがある場合'}
      </div>
    </CustomTooltip>
  );
});
